interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/7a20facf-c180-43e4-bc04-b977be664223.png" 
              alt="ZALETELJ d.o.o." 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              ZALETELJ
            </span>
          </div>

          <div className="hidden md:flex items-center gap-10">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-gray-200'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-gray-200'
              }`}
            >
              VPN Features
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-gray-200'
              }`}
            >
              Security
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-gray-200'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('support')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-gray-200'
              }`}
            >
              Support
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className={`hidden md:flex items-center gap-2 px-6 py-2.5 rounded-full border-2 transition-all whitespace-nowrap ${
              scrolled
                ? 'border-cyan-500 text-cyan-500 hover:bg-cyan-500 hover:text-white'
                : 'border-white text-white hover:bg-white hover:text-gray-900'
            }`}
          >
            <i className="ri-lock-line"></i>
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
